import { useState } from "react";
import { FormNotice } from "@/components/forms/FormNotice";
import { RecaptchaField } from "@/components/forms/RecaptchaField";
import { subscribeNewsletter } from "../../lib/api";
import { recaptchaSiteKey } from "@/lib/recaptcha";

function EyebrowIcon() {
  return (
    <svg width="100%" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        opacity="0.2"
        d="M14.1981 11.1472L10.3246 12.5746L8.89724 16.4481C8.85782 16.5549 8.78661 16.6471 8.6932 16.7122C8.59979 16.7772 8.48867 16.8121 8.37482 16.8121C8.26097 16.8121 8.14986 16.7772 8.05645 16.7122C7.96304 16.6471 7.89182 16.5549 7.8524 16.4481L6.42506 12.5746L2.55154 11.1472C2.44473 11.1078 2.35258 11.0366 2.28749 10.9432C2.2224 10.8498 2.1875 10.7387 2.1875 10.6248C2.1875 10.511 2.2224 10.3999 2.28749 10.3064C2.35258 10.213 2.44473 10.1418 2.55154 10.1024L6.42506 8.67506L7.8524 4.80154C7.89182 4.69473 7.96304 4.60258 8.05645 4.53749C8.14986 4.4724 8.26097 4.4375 8.37482 4.4375C8.48867 4.4375 8.59979 4.4724 8.6932 4.53749C8.78661 4.60258 8.85782 4.69473 8.89724 4.80154L10.3246 8.67506L14.1981 10.1024C14.3049 10.1418 14.3971 10.213 14.4622 10.3064C14.5272 10.3999 14.5621 10.511 14.5621 10.6248C14.5621 10.7387 14.5272 10.8498 14.4622 10.9432C14.3971 11.0366 14.3049 11.1078 14.1981 11.1472Z"
        fill="currentColor"
      />
      <path
        d="M14.3952 9.57453L10.7685 8.23437L9.43255 4.60484C9.35343 4.38992 9.2103 4.20443 9.02245 4.07341C8.83461 3.94239 8.6111 3.87214 8.38208 3.87214C8.15305 3.87214 7.92954 3.94239 7.7417 4.07341C7.55386 4.20443 7.41072 4.38992 7.33161 4.60484L5.98723 8.23437L2.3577 9.57031C2.14278 9.64942 1.95729 9.79256 1.82627 9.9804C1.69525 10.1682 1.625 10.3918 1.625 10.6208C1.625 10.8498 1.69525 11.0733 1.82627 11.2612C1.95729 11.449 2.14278 11.5921 2.3577 11.6712L5.98723 13.0156L7.32317 16.6452C7.40228 16.8601 7.54542 17.0456 7.73326 17.1766C7.9211 17.3076 8.14462 17.3779 8.37364 17.3779C8.60266 17.3779 8.82617 17.3076 9.01402 17.1766C9.20186 17.0456 9.34499 16.8601 9.42411 16.6452L10.7685 13.0156L14.398 11.6797C14.6129 11.6006 14.7984 11.4574 14.9294 11.2696C15.0605 11.0818 15.1307 10.8582 15.1307 10.6292C15.1307 10.4002 15.0605 10.1767 14.9294 9.98884C14.7984 9.801 14.6129 9.65786 14.398 9.57875L14.3952 9.57453ZM10.1357 12.0467C10.0593 12.0749 9.98998 12.1192 9.93244 12.1768C9.8749 12.2343 9.83053 12.3036 9.80239 12.38L8.37786 16.2395L6.95614 12.3828C6.92804 12.3057 6.8834 12.2356 6.82534 12.1775C6.76727 12.1195 6.6972 12.0748 6.62005 12.0467L2.76341 10.625L6.62005 9.20328C6.6972 9.17519 6.76727 9.13054 6.82534 9.07248C6.8834 9.01441 6.92804 8.94434 6.95614 8.86719L8.37786 5.01055L9.79958 8.86719C9.82772 8.94354 9.87209 9.01288 9.92963 9.07042C9.98717 9.12796 10.0565 9.17233 10.1329 9.20047L13.9923 10.625L10.1357 12.0467ZM10.6279 3.3125C10.6279 3.16332 10.6871 3.02024 10.7926 2.91475C10.8981 2.80926 11.0412 2.75 11.1904 2.75H12.3154V1.625C12.3154 1.47582 12.3746 1.33274 12.4801 1.22725C12.5856 1.12176 12.7287 1.0625 12.8779 1.0625C13.027 1.0625 13.1701 1.12176 13.2756 1.22725C13.3811 1.33274 13.4404 1.47582 13.4404 1.625V2.75H14.5654C14.7145 2.75 14.8576 2.80926 14.9631 2.91475C15.0686 3.02024 15.1279 3.16332 15.1279 3.3125C15.1279 3.46168 15.0686 3.60476 14.9631 3.71025C14.8576 3.81574 14.7145 3.875 14.5654 3.875H13.4404V5C13.4404 5.14918 13.3811 5.29226 13.2756 5.39775C13.1701 5.50324 13.027 5.5625 12.8779 5.5625C12.7287 5.5625 12.5856 5.50324 12.4801 5.39775C12.3746 5.29226 12.3154 5.14918 12.3154 5V3.875H11.1904C11.0412 3.875 10.8981 3.81574 10.7926 3.71025C10.6871 3.60476 10.6279 3.46168 10.6279 3.3125ZM17.9404 6.6875C17.9404 6.83668 17.8811 6.97976 17.7756 7.08525C17.6701 7.19074 17.527 7.25 17.3779 7.25H16.8154V7.8125C16.8154 7.96168 16.7561 8.10476 16.6506 8.21025C16.5451 8.31574 16.402 8.375 16.2529 8.375C16.1037 8.375 15.9606 8.31574 15.8551 8.21025C15.7496 8.10476 15.6904 7.96168 15.6904 7.8125V7.25H15.1279C14.9787 7.25 14.8356 7.19074 14.7301 7.08525C14.6246 6.97976 14.5654 6.83668 14.5654 6.6875C14.5654 6.53832 14.6246 6.39524 14.7301 6.28975C14.8356 6.18426 14.9787 6.125 15.1279 6.125H15.6904V5.5625C15.6904 5.41332 15.7496 5.27024 15.8551 5.16475C15.9606 5.05926 16.1037 5 16.2529 5C16.402 5 16.5451 5.05926 16.6506 5.16475C16.7561 5.27024 16.8154 5.41332 16.8154 5.5625V6.125H17.3779C17.527 6.125 17.6701 6.18426 17.7756 6.28975C17.8811 6.39524 17.9404 6.53832 17.9404 6.6875Z"
        fill="currentColor"
      />
    </svg>
  );
}

function CloudLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 450 514" fill="none" aria-hidden="true">
      <g clipPath="url(#clip0_blog_cta_left)">
        <circle cx="-34" cy="444" r="179" fill="currentColor" />
        <circle cx="-39" cy="179" r="179" fill="currentColor" />
        <circle cx="189" cy="317" r="179" fill="currentColor" />
        <circle cx="271" cy="496" r="179" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_blog_cta_left">
          <rect width="450" height="514" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

function CloudRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 450 514" fill="none" aria-hidden="true">
      <g clipPath="url(#clip0_blog_cta_right)">
        <circle cx="179" cy="179" r="179" transform="matrix(-1 0 0 1 663 265)" fill="currentColor" />
        <circle cx="179" cy="179" r="179" transform="matrix(-1 0 0 1 668 0)" fill="currentColor" />
        <circle cx="179" cy="179" r="179" transform="matrix(-1 0 0 1 440 138)" fill="currentColor" />
        <circle cx="179" cy="179" r="179" transform="matrix(-1 0 0 1 358 317)" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_blog_cta_right">
          <rect width="450" height="514" fill="currentColor" transform="matrix(-1 0 0 1 450 0)" />
        </clipPath>
      </defs>
    </svg>
  );
}

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function BlogNewsletterSignupSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [captchaInstanceKey, setCaptchaInstanceKey] = useState(0);
  const [errorTarget, setErrorTarget] = useState<"email" | "captcha" | "form" | null>(null);
  const captchaConfigured = recaptchaSiteKey.length > 0;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (status === "loading") return;

    const normalizedEmail = email.trim();
    if (!normalizedEmail) {
      setStatus("error");
      setErrorTarget("email");
      setErrorMessage("Enter your email address to join the newsletter.");
      return;
    }
    if (!emailPattern.test(normalizedEmail)) {
      setStatus("error");
      setErrorTarget("email");
      setErrorMessage("Use a valid email address so we know where to send updates.");
      return;
    }
    if (!captchaConfigured) {
      setStatus("error");
      setErrorTarget("form");
      setErrorMessage("reCAPTCHA is unavailable right now. Please try again later.");
      return;
    }
    if (!captchaToken) {
      setStatus("error");
      setErrorTarget("captcha");
      setErrorMessage("Check the reCAPTCHA to finish subscribing.");
      return;
    }

    setStatus("loading");
    setErrorMessage(null);
    setSuccessMessage(null);
    setErrorTarget(null);
    const { data, error } = await subscribeNewsletter(normalizedEmail, captchaToken);
    if (error) {
      setStatus("error");
      setErrorTarget("form");
      setErrorMessage(error.message || "Something went wrong. Please try the reCAPTCHA again in a moment.");
    } else {
      setStatus("success");
      setEmail("");
      setSuccessMessage(
        data?.alreadySubscribed
          ? "You're already on the list."
          : "Thank you. You're on the list.",
      );
    }

    setCaptchaToken(null);
    setCaptchaInstanceKey((current) => current + 1);
  }

  return (
    <section className="relative mt-auto overflow-clip bg-[radial-gradient(circle_farthest-side_at_50%_210%,var(--color-yellow-brand),transparent)]">
      <div className="px-[var(--site-margin)]">
        <div className="mx-auto w-full max-w-[80rem]">
          <div className="pt-16 pb-[9.38rem] max-[991px]:pt-16 max-[991px]:pb-24 max-[767px]:pt-12 max-[767px]:pb-16">
            <div className="relative z-[2] text-center">
              <div
                data-wf--eyebrow--variant="yellow"
                className="mx-auto flex w-fit justify-start rounded-full border-[0.09rem] border-[rgb(118_42_92_/_10%)] bg-[color-mix(in_srgb,#ffffff_40%,transparent)] p-[0.38rem] font-semibold text-yellow-brand"
              >
                <div className="flex items-center gap-1 rounded-[inherit] border-[inherit] bg-white px-[0.88rem] py-2">
                  <div className="flex w-5 flex-col">
                    <EyebrowIcon />
                  </div>
                  <div className="m-0 text-[0.88rem] font-semibold leading-none text-inherit">Newsletter</div>
                </div>
              </div>
              <div className="w-full pt-6 max-[767px]:pt-5" />
              <h2 className="m-0 font-display text-[clamp(2rem,1.5714rem+2.1429vw,3.5rem)] font-medium leading-[1.15] text-[#1f0a18]">
                Never Miss <span className="text-[var(--text-color-alternate)]">A Beat</span>
              </h2>
              <div className="w-full pt-6 max-[767px]:pt-5" />
              <p className="mx-auto my-0 max-w-[44ch] text-[clamp(1rem,0.9643rem+0.1786vw,1.125rem)] font-medium leading-normal text-[#4a4a4a]">
                Be the first to know when new tutorials drop—and receive exclusive content and offers.
              </p>
              <div id="Newsletter-Form" className="mx-auto mt-8 max-w-[31.5rem]">
                {status === "success" ? (
                  <FormNotice
                    className="rounded-[1.4rem]"
                    message={successMessage ?? "Thank you. You're on the list."}
                    role="status"
                    tone="success"
                  />
                ) : (
                  <form
                    id="wf-form-Newsletter-Form"
                    name="wf-form-Newsletter-Form"
                    data-name="Newsletter Form"
                    noValidate
                    className="overflow-visible rounded-[2rem] bg-white px-5 py-5 shadow-[0_20px_60px_rgb(31_10_24/8%)] max-[767px]:border max-[767px]:border-neutral-lighter max-[479px]:rounded-[1.4rem] max-[479px]:px-3 max-[479px]:py-4"
                    onSubmit={handleSubmit}
                  >
                    <div className="flex items-center gap-3 max-[479px]:flex-col">
                      <input
                        className={`min-h-[3.6rem] flex-1 appearance-none rounded-full border bg-white py-3 px-5 text-center font-sans text-sm leading-[1.42857] text-[#1f0a18] placeholder:text-[#999999] placeholder:text-center focus:outline-none max-[479px]:min-h-12 max-[479px]:w-full max-[479px]:shadow-[0_0_15px_rgb(242_164_53_/_6%)] ${
                          errorTarget === "email"
                            ? "border-[rgb(118_42_92_/_25%)] bg-[color-mix(in_srgb,#fff8fa_86%,#ffffff)]"
                            : "border-transparent focus:border-[color-mix(in_srgb,var(--color-yellow-brand)_35%,#ffffff)] max-[479px]:border-neutral-light"
                        }`}
                        maxLength={256}
                        name="Email-Address"
                        placeholder="Enter your email here"
                        type="email"
                        id="newsletter-form"
                        aria-label="Email address"
                        aria-invalid={errorTarget === "email"}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (errorTarget === "email") {
                            setErrorTarget(null);
                            setErrorMessage(null);
                            setStatus("idle");
                          }
                        }}
                        disabled={status === "loading"}
                      />
                      <input
                        type="submit"
                        data-wait="Please wait..."
                        className="m-0 cursor-pointer rounded-full border-0 bg-yellow-brand py-3 pr-[2.4rem] pl-6 text-sm font-medium leading-none text-white transition-colors duration-200 hover:bg-[color-mix(in_srgb,var(--color-yellow-brand)_92%,#000000)] disabled:cursor-not-allowed disabled:opacity-60 max-[479px]:w-full"
                        style={{ backgroundImage: 'url("https://cdn.prod.website-files.com/686229256a807206c1874545/686d7321f0a5a04e349f4a70_Alt%20Arrow%20Right.svg")', backgroundPosition: '85% 50%', backgroundRepeat: 'no-repeat', backgroundSize: 'auto' }}
                        value={status === "loading" ? "Please wait..." : "Subscribe"}
                        disabled={status === "loading" || !captchaConfigured}
                      />
                    </div>
                    <RecaptchaField
                      key={captchaInstanceKey}
                      className="mt-4"
                      invalid={errorTarget === "captcha"}
                      onTokenChange={(token) => {
                        setCaptchaToken(token);
                        if (token) {
                          if (errorTarget === "captcha") {
                            setErrorTarget(null);
                            setErrorMessage(null);
                            setStatus("idle");
                          }
                        }
                      }}
                    />
                  </form>
                )}
                {status === "error" && (
                  <FormNotice
                    className="mt-3"
                    message={errorMessage ?? "Oops! Something went wrong while submitting the form."}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 right-auto z-[1] flex text-white max-[991px]:inset-y-auto max-[991px]:bottom-0 max-[991px]:w-[18.75rem] max-[767px]:ml-[-15vw] max-[479px]:ml-[-50vw]">
        <CloudLeft />
      </div>
      <div className="pointer-events-none absolute inset-y-0 right-0 left-auto z-[1] flex text-white max-[991px]:inset-y-auto max-[991px]:bottom-0 max-[991px]:w-[18.75rem] max-[767px]:mr-[-15vw] max-[479px]:mr-[-50vw]">
        <CloudRight />
      </div>
    </section>
  );
}

export default BlogNewsletterSignupSection;
